import React, { FC, useState } from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import routes from 'src/routes'
import Amplitude from 'src/utils/amplitudeHelper'
import { setPageTitle, setPreviousPage } from 'src/ducks/onDemand'
import { day1Slides} from '../../categories'
import { DocumentViewer } from 'src/components/GlobalModals/DocumentViewer'

export const Day1Slides: FC<RouteComponentProps> = () => {
  const dispatch = useDispatch()
  
  useEffect(() => {
    dispatch(setPageTitle('Gallery'))
    dispatch(setPreviousPage(routes.onDemand))
  }, [dispatch])

  const [selectedTopic, setSelectedTopic] = useState(null)
  // const [showModal, setShowModal] = useState(false)
  // const [loading, setLoading] = useState(true)


  const handlePlayback = (item) => {
    // setShowModal(true)
    setSelectedTopic(item)
    // setLoading(true)
    Amplitude.clickGalleryItem(item.title)
  }

  return (
    <>
      <div className="grid-container">
        {day1Slides.length === 0 ? (
          <p>No files available. Check back soon!</p>
        ) : (
          day1Slides.map((item) => (
            <div onClick={() => handlePlayback(item)} className="card-thumbnail" key={item.title}>
              <img src={item.thumbnail} width="100%" alt="thumbnail" />
              <span>{item.title}</span>
            </div>
          ))
        )}
      </div>
      <DocumentViewer file={selectedTopic} setDocumentSelected={setSelectedTopic}/>
      {/* <StyledModal show={showModal} onHide={closeModal} size="lg" aria-labelledby="vimeoPlayer" centered>
        <Modal.Header closeButton>
          <Modal.Title id="vimeoPlayer">
            <b>{currentVideo?.title}</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div id="vimeoContainer">
            {loading && <Loader loading={loading} />}
            
          </div>
        </Modal.Body>
      </StyledModal> */}
    </>
  )
}
